import GET_CATEGORIES from "../plugins/getCategories";

export default function WHOLESALE() {
  const [w,d] = [window,document]
  d.addEventListener('DOMContentLoaded',()=>{
    // リストコンテナのクラス変更
    const list_container = d.querySelector('.element_list')
    const detail_container = d.querySelector('.element_detail')
    if(list_container){
      list_container.classList.remove('element_list')
      list_container.classList.add('p-wholesale__list')
    }
    if(detail_container){
      detail_container.classList.remove('element_detail')
      detail_container.classList.add('p-wholesale__detail')
    }
    $('.paginationbox').appendTo('#container')

    GET_CATEGORIES('.c-catelist',{
      itemClass: 'button button-text'
    }).done(() => {
      const id = w.location.search.match(/[?|&]article=([\d]+)?/)
      if(id && id[1]){
        $.getArticles({
          content: 'wholesale',post_id: id[1]
        }).done(query => {
          $('.c-catelist').currentMenu({
            mode:0,default:999,
            url: `${location.pathname}?mode=list&cat=${query[0]['category']}`
          })
        })
      }
    })

    // カテゴリブロックの移動
    {
      $('.c-catelist').parents('.block').addClass('c-catelist-block')
      $('.block_foot.c-catelist-block').appendTo('#container')
    }

  })
}